class VracRecipe extends HTMLElement {
    constructor() {
        super();

        this.init();

        this.querySelectorAll('.video-section__video-iframe').forEach(function (videoElement) {
            videoElement.addEventListener('click', function (e) {
                let opener = e.currentTarget.querySelector('.video-section__video-play').getAttribute('data-handle');
                document.body.classList.add('modal-open');
                // ne pas ouvrir en plein écran
                document.querySelector(`.${opener}`).setAttribute('playsinline', '');
                document.querySelector(`.${opener}`).closest('.modal--video').classList.add('opened');
                document.querySelector(`.${opener}`).play();


                document.querySelector(`.${opener}`).closest('.modal--video').querySelector('video').addEventListener('mouseover', function () {
                    document.querySelector(`.${opener}`).closest('.modal--video').querySelector('video').setAttribute('controls', 'controls');
                })
                document.querySelector(`.${opener}`).closest('.modal--video').querySelector('video').addEventListener('click', function () {
                    document.querySelector(`.${opener}`).closest('.modal--video').querySelector('video').setAttribute('controls', 'controls');
                });

                document.querySelector(`.${opener}`).closest('.modal--video').querySelector('svg').addEventListener('click', function () {
                    document.querySelector(`.${opener}`).pause();
                    document.querySelector(`.${opener}`).closest('.modal--video').classList.remove('opened');
                    document.body.classList.remove('modal-open');
                });
            });
        });

        document.querySelectorAll('.modal--video').forEach(function (modal) {
            modal.addEventListener('click', function (e) {
                console.log(e.currentTarget);
                if (!e.target.closest('.modal-video__container-container') && e.currentTarget.classList.contains('opened')) {
                    modal.querySelector('video').pause();
                    modal.classList.remove('opened');
                    document.body.classList.remove('modal-open');
                }
            });
        });
    }

    init() {
        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',

            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },

            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
        });
    }
}

customElements.define('vrac-recipe', VracRecipe);